//-------------------------------------------------------------------------
// Custome paper specifically with a light grey background
//-------------------------------------------------------------------------

import { withStyles } from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import colors from "../../assets/style/colors";

const PaperLightGrey = withStyles((theme) => ({
    root: {
        backgroundColor: colors.lightGrey,
    }
}))(Paper);

export default PaperLightGrey;